import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShortlistDrawer, useShortlistStore } from '@/features/shortlist';

export function ShortlistButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const totalItems = useShortlistStore((s) =>
    s.lists.reduce((sum, l) => sum + l.comuneIstats.length, 0),
  );

  return (
    <>
      <button
        type="button"
        data-tour="shortlist"
        data-testid="shortlist-button"
        onClick={() => setOpen(true)}
        className="inline-flex h-9 min-w-9 items-center justify-center gap-1 rounded-md border border-[color:var(--color-ink-100)] px-2 text-sm text-[color:var(--color-ink-700)] hover:bg-[color:var(--color-paper-2)] sm:px-2.5"
        title={t('shortlist.open')}
        aria-label={t('shortlist.open')}
      >
        <span aria-hidden="true">★</span>
        <span className="hidden sm:inline">{t('shortlist.title')}</span>
        {totalItems > 0 && (
          <span className="ml-0.5 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[color:var(--color-terra-600)] px-1.5 text-[11px] font-semibold text-[color:var(--color-paper)]">
            {totalItems}
          </span>
        )}
      </button>
      <ShortlistDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
